import { ColorEnum } from '@/constants/color'
import Typography from '@/features/ui/typography'
import { FC } from 'react'
import { View } from 'react-native'
import { createStyleSheet, useStyles } from 'react-native-unistyles'

interface SummaryRowProps {
    label: string
    value: string
    valueColor?: ColorEnum
    emphasized?: boolean
}

const SummaryRow: FC<SummaryRowProps> = ({ label, value, valueColor, emphasized = false }) => {
    const { styles } = useStyles(stylesheet)

    return (
        <View style={styles.row}>
            <Typography.Heading variant={emphasized ? 'h3' : 'h5'} style={styles.cell}>
                {label}
            </Typography.Heading>
            <Typography.Heading
                variant={emphasized ? 'h3' : 'h5'}
                style={[styles.cell, styles.value, valueColor && { color: valueColor }]}
            >
                {value}
            </Typography.Heading>
        </View>
    )
}

const stylesheet = createStyleSheet({
    row: {
        flexDirection: 'row',
    },
    cell: {
        flex: 1,
    },
    value: {
        textAlign: 'right',
    },
})

export default SummaryRow
